import React from 'react';
import { SimpleTag as Tag } from '@atlaskit/tag';
export var TAG_TYPE_TEST_ID = 'link-datasource-render-type--tag';
var TagRenderType = function TagRenderType(_ref) {
  var _tag$color;
  var tag = _ref.tag,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? TAG_TYPE_TEST_ID : _ref$testId;
  var text = tag === null || tag === void 0 ? void 0 : tag.text;
  if (!(text && typeof text === 'string')) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(Tag, {
    text: text,
    testId: testId,
    appearance: 'default',
    color: (_tag$color = tag === null || tag === void 0 ? void 0 : tag.color) !== null && _tag$color !== void 0 ? _tag$color : 'standard',
    href: tag === null || tag === void 0 ? void 0 : tag.url
  });
};
export default TagRenderType;